module.exports = __webpack_public_path__ + "static/media/TheCurseofEelgrassBog.1d0136c3.jpg";